var link_viewer_default = {
  "fontElementMap": "DhOdc",
  "link": "W2wmu",
  "linkInEditor": "of3Lx",
  "linkInViewer": "_0cOko",
  "toolbarUrlContainer": "SpMKA",
  "toolbarUrl": "LntaG",
  "toolbarUrlAnchor": "yRTOI"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
